// export const products = [
//   {
//     id: 1,
//     name: "Vitamin C Brightening Serum",
//     shortName: "VC Serum 30ml",
//     category: "Skincare",
//     concern: ["Uneven Tone", "Dark Spots"],
//     price: 1299,
//     originalPrice: 1599,
//     size: "30ml",
//     rating: 4.8,
//     reviews: 342,
//     badge: "Bestseller",
//     description: "A potent 15% Vitamin C serum that visibly brightens skin, reduces dark spots and evens skin tone in 4 weeks. Formulated with Ferulic Acid and Vitamin E for maximum stability and efficacy.",
//     ingredients: ["Ascorbic Acid 15%", "Ferulic Acid", "Vitamin E", "Hyaluronic Acid"],
//     image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
//     images: [
//       "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
//       "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=600&q=80",
//       "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&q=80",
//     ],
//   },
//   {
//     id: 2,
//     name: "Salicylic Acid Exfoliant",
//     shortName: "SA Serum 30ml",
//     category: "Skincare",
//     concern: ["Acne", "Acne Scars", "Oily Skin"],
//     price: 899,
//     originalPrice: 1199,
//     size: "30ml",
//     rating: 4.7,
//     reviews: 218,
//     badge: "New",
//     description: "2% Salicylic Acid serum that deeply unclogs pores, reduces active acne and minimizes appearance of acne scars over time.",
//     ingredients: ["Salicylic Acid 2%", "Zinc PCA", "Niacinamide", "Green Tea Extract"],
//     image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=600&q=80",
//     images: [
//       "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=600&q=80",
//       "https://images.unsplash.com/photo-1570194065650-d99fb4abbd90?w=600&q=80",
//     ],
//   },
//   {
//     id: 3,
//     name: "Vitamin C Serum Mini",
//     shortName: "VC Serum 10ml",
//     category: "Skincare",
//     concern: ["Uneven Tone", "Dry Skin"],
//     price: 599,
//     originalPrice: 699,
//     size: "10ml",
//     rating: 4.6,
//     reviews: 157,
//     badge: null,
//     description: "Travel-size version of our bestselling Vitamin C serum. Perfect to try before committing to the full size.",
//     ingredients: ["Ascorbic Acid 15%", "Ferulic Acid", "Vitamin E"],
//     image: "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=600&q=80",
//     images: [
//       "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=600&q=80",
//       "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
//     ],
//   },
//   {
//     id: 4,
//     name: "Salicylic Acid Mini",
//     shortName: "SA Serum 10ml",
//     category: "Skincare",
//     concern: ["Acne", "Oily Skin"],
//     price: 499,
//     originalPrice: 599,
//     size: "10ml",
//     rating: 4.5,
//     reviews: 98,
//     badge: null,
//     description: "Travel-size SA serum for on-the-go acne control. Great for beginners.",
//     ingredients: ["Salicylic Acid 2%", "Zinc PCA", "Niacinamide"],
//     image: "https://media6.ppl-media.com/tr:h-235,w-235,c-at_max,dpr-2,q-40/static/img/product/225842/minimalist-salicylic-acid-2-percentage-serum-for-blackheads-pore-tightening-oil-control-and-acne-breakouts_1_display_1750326715_877ee35c.jpg",
//     images: ["https://media6.ppl-media.com/tr:h-235,w-235,c-at_max,dpr-2,q-40/static/img/product/225842/minimalist-salicylic-acid-2-percentage-serum-for-blackheads-pore-tightening-oil-control-and-acne-breakouts_1_display_1750326715_877ee35c.jpg"],
//   },
//   {
//     id: 5,
//     name: "VC + SA Combo Serum",
//     shortName: "VC+SA 30ml",
//     category: "Skincare",
//     concern: ["Acne Scars", "Uneven Tone", "Fine Lines"],
//     price: 1599,
//     originalPrice: 2199,
//     size: "30ml",
//     rating: 4.9,
//     reviews: 429,
//     badge: "Limited",
//     description: "Our most advanced formula combining Vitamin C and Salicylic Acid for complete skin transformation. Addresses pigmentation, acne and signs of aging simultaneously.",
//     ingredients: ["Ascorbic Acid 10%", "Salicylic Acid 1%", "Niacinamide", "Ferulic Acid", "Hyaluronic Acid"],
//     image: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=600&q=80",
//     images: [
//       "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=600&q=80",
//       "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
//       "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=600&q=80",
//     ],
//   },
//   {
//     id: 6,
//     name: "VC + SA Mini Combo",
//     shortName: "VC+SA 10ml",
//     category: "Skincare",
//     concern: ["Acne Scars", "Uneven Tone"],
//     price: 799,
//     originalPrice: 999,
//     size: "10ml",
//     rating: 4.7,
//     reviews: 183,
//     badge: null,
//     description: "Mini combo to experience the power of our dual-action formula before investing in full size.",
//     ingredients: ["Ascorbic Acid 10%", "Salicylic Acid 1%", "Niacinamide"],
//     image: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&q=80",
//     images: ["https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&q=80"],
//   },
// ];

export const products = [
  {
    id: 1,
    name: "Vitamin C Brightening Serum",
    shortName: "Vitamin C 30ml",
    category: "Skincare",
    concern: ["Uneven Tone", "Dark Spots"],
    price: 1299,
    originalPrice: 1599,
    size: "30ml",
    rating: 4.8,
    reviews: 342,
    badge: "Bestseller",
    description:
      "A potent 15% Vitamin C serum that visibly brightens skin, reduces dark spots, and evens skin tone.",
    ingredients: [
      "Ascorbic Acid 15%",
      "Ferulic Acid",
      "Vitamin E",
      "Hyaluronic Acid",
    ],
    howToUse: [
      "Cleanse your face thoroughly and pat dry.",
      "Apply 2-3 drops of serum to your face and neck.",
      "Gently massage until fully absorbed.",
      "Follow with a moisturizer to lock in hydration.",
      "Use sunscreen during the daytime for best results.",
    ],
    benefits: [
      "Brightens skin tone",
      "Reduces dark spots",
      "Boosts collagen production",
      "Protects against environmental damage",
    ],
    suitableFor: [
      "All skin types",
      "Dull & tired skin",
      "Hyperpigmentation",
      "Uneven skin tone",
    ],
    image:
      "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
      "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=600&q=80",
      "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&q=80",
    ],
  },

  {
    id: 2,
    name: "Vitamin C Brightening Serum Mini",
    shortName: "Vitamin C 10ml",
    category: "Skincare",
    concern: ["Uneven Tone", "Dark Spots"],
    price: 599,
    originalPrice: 699,
    size: "10ml",
    rating: 4.6,
    reviews: 157,
    badge: null,
    description:
      "Travel-size version of our Vitamin C serum. Perfect for trying the product before purchasing the full-size bottle.",
    ingredients: [
      "Ascorbic Acid 15%",
      "Ferulic Acid",
      "Vitamin E",
    ],
    howToUse: [
      "Cleanse your face thoroughly and pat dry.",
      "Apply 2-3 drops of serum to your face and neck.",
      "Gently massage until fully absorbed.",
      "Follow with a moisturizer to lock in hydration.",
      "Use sunscreen during the daytime for best results.",
    ],
    benefits: [
      "Brightens skin tone",
      "Reduces dark spots",
      "Boosts collagen production",
    ],
    suitableFor: [
      "All skin types",
      "Dull & tired skin",
      "Hyperpigmentation",
    ],
    image:
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=600&q=80",
      "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80",
    ],
  },

  {
    id: 3,
    name: "Salicylic Acid Exfoliating Serum",
    shortName: "Salicylic Acid 30ml",
    category: "Skincare",
    concern: ["Acne", "Acne Scars", "Oily Skin"],
    price: 899,
    originalPrice: 1199,
    size: "30ml",
    rating: 4.7,
    reviews: 218,
    badge: "New",
    description:
      "A 2% Salicylic Acid serum that deeply unclogs pores, reduces active acne, and helps control excess oil.",
    ingredients: [
      "Salicylic Acid 2%",
      "Zinc PCA",
      "Niacinamide",
      "Green Tea Extract",
    ],
    howToUse: [
      "Cleanse your face thoroughly and pat dry.",
      "Apply 2-3 drops of serum to your face and neck, focusing on areas with active acne.",
      "Gently massage until fully absorbed.",
      "Follow with a moisturizer to prevent dryness.",
      "Use only in your evening routine. Start with alternate day usage if you have sensitive skin.",
    ],
    benefits: [
      "Unclogs pores",
      "Reduces active acne",
      "Controls excess oil",
      "Minimizes acne scars",
      "Exfoliates gently",
    ],
    suitableFor: [
      "Oily skin",
      "Acne-prone skin",
      "Clogged pores & blackheads",
      "Combination skin",
    ],
    image:
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=600&q=80",
      "https://images.unsplash.com/photo-1570194065650-d99fb4abbd90?w=600&q=80",
    ],
  },

  {
    id: 4,
    name: "Salicylic Acid Exfoliating Serum Mini",
    shortName: "Salicylic Acid 10ml",
    category: "Skincare",
    concern: ["Acne", "Oily Skin"],
    price: 499,
    originalPrice: 599,
    size: "10ml",
    rating: 4.5,
    reviews: 98,
    badge: null,
    description:
      "Travel-size Salicylic Acid serum for on-the-go acne control and oil management.",
    ingredients: [
      "Salicylic Acid 2%",
      "Zinc PCA",
      "Niacinamide",
    ],
    howToUse: [
      "Cleanse your face thoroughly and pat dry.",
      "Apply 2-3 drops of serum to your face and neck, focusing on areas with active acne.",
      "Gently massage until fully absorbed.",
      "Follow with a moisturizer to prevent dryness.",
      "Use only in your evening routine.",
    ],
    benefits: [
      "Unclogs pores",
      "Reduces active acne",
      "Controls excess oil",
    ],
    suitableFor: [
      "Oily skin",
      "Acne-prone skin",
      "Combination skin",
    ],
    image:
      "https://media6.ppl-media.com/tr:h-235,w-235,c-at_max,dpr-2,q-40/static/img/product/225842/minimalist-salicylic-acid-2-percentage-serum-for-blackheads-pore-tightening-oil-control-and-acne-breakouts_1_display_1750326715_877ee35c.jpg",
    images: [
      "https://media6.ppl-media.com/tr:h-235,w-235,c-at_max,dpr-2,q-40/static/img/product/225842/minimalist-salicylic-acid-2-percentage-serum-for-blackheads-pore-tightening-oil-control-and-acne-breakouts_1_display_1750326715_877ee35c.jpg",
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    text: "The Vitamin C serum has completely transformed my skin. My dark spots have faded significantly and my skin looks so much more radiant. Worth every rupee!",
    product: "Vitamin C Brightening Serum",
    avatar: "PS",
  },
  {
    id: 2,
    name: "Ananya Krishnan",
    location: "Bangalore",
    rating: 5,
    text: "I've struggled with acne for years. The SA serum cleared my skin in just 3 weeks. I finally feel confident without makeup. Metameni has been a game changer.",
    product: "Salicylic Acid Exfoliant",
    avatar: "AK",
  },
  {
    id: 3,
    name: "Riya Malhotra",
    location: "Delhi",
    rating: 5,
    text: "Clean ingredients, dermatologist tested, and actually works! The combo serum is my holy grail. My skin has never looked better at 28.",
    product: "VC + SA Combo Serum",
    avatar: "RM",
  },
];
